import { render, staticRenderFns } from "./points-info.vue?vue&type=template&id=3ec60836&scoped=true&lang=pug&"
import script from "./points-info.vue?vue&type=script&lang=js&"
export * from "./points-info.vue?vue&type=script&lang=js&"
import style0 from "./points-info.vue?vue&type=style&index=0&id=3ec60836&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec60836",
  null
  
)

export default component.exports